/**
 * Named route middleware: optional global kill-switch for generic admin surfaces.
 *
 * - When `public.NUXT_MY_APP_ADMIN_UI_ENABLED` is explicitly `false`, redirect home.
 * - Any other value (including undefined) keeps admin routes enabled.
 */
export default defineNuxtRouteMiddleware(() => {
    const config = useRuntimeConfig() as {
        public?: {
            adminUiEnabled?: string
        }
    }
    if (config.public?.adminUiEnabled === 'false') {
        return navigateTo('/', { replace: true })
    }
})
